(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9832],{

/***/ 5500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ WelcomePage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/views/parts/bases/Center.tsx
var Center = __webpack_require__(4582);
;// CONCATENATED MODULE: ./public/images/signupLoginFrame.png
/* harmony default export */ var signupLoginFrame = ({"src":"/_next/static/media/signupLoginFrame.023cb7a1.png","height":972,"width":2265,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAD1BMVEUBCgsACwsBGRoAHx8AAABFIZ+3AAAABHRSTlP27+LYVmBz9AAAAAlwSFlzAAAhOAAAITgBRZYxYAAAABhJREFUCJljYGIAAyYGRhYwYGBgZgQDJgAB/wApQI06gAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
// EXTERNAL MODULE: ./src/views/parts/bases/VStack.tsx
var VStack = __webpack_require__(2326);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(2120);
// EXTERNAL MODULE: ./src/views/parts/bases/Absolute.tsx
var Absolute = __webpack_require__(3975);
// EXTERNAL MODULE: ./src/views/parts/bases/HStack.tsx
var HStack = __webpack_require__(1078);
// EXTERNAL MODULE: ./src/views/parts/buttons/PinkNeonButton.tsx
var PinkNeonButton = __webpack_require__(5167);
// EXTERNAL MODULE: ./src/views/parts/bases/Text.tsx
var Text = __webpack_require__(1695);
// EXTERNAL MODULE: ./src/views/parts/bases/Space.tsx
var Space = __webpack_require__(2952);
// EXTERNAL MODULE: ./src/views/parts/commons/GlobalNavigationHeader/Layout.tsx + 17 modules
var GlobalNavigationHeader_Layout = __webpack_require__(9275);
// EXTERNAL MODULE: ./src/views/parts/commons/Head.tsx
var Head = __webpack_require__(656);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/views/pages/WelcomePage/Layout.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var Layout = function Layout(props) {
  var _useTranslation = (0,es/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Welcome"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
      className: "h-full w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GlobalNavigationHeader_Layout/* Layout */.A, _objectSpread({}, props.GlobalNavigationHeaderProps)), /*#__PURE__*/(0,jsx_runtime.jsx)(Center/* Center */.M, {
        className: "h-full w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
          className: "aspect-[2265/972] w-[700px]",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            layout: "fill",
            src: signupLoginFrame,
            alt: ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Absolute/* Absolute */.e, {
            className: "top-0 left-0 h-full w-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(VStack/* VStack */.g, {
              className: "h-full w-full items-center justify-center p-12",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "text-2xl font-bold text-white",
                children: t('WelcomePage.title')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                className: "text-center text-neutral-500",
                children: t('WelcomePage.message')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Space/* Space */.T, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(HStack/* HStack */.U, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PinkNeonButton/* PinkNeonButton */.u, {
                  onClick: props.onClickSignUpButton,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                    children: t('WelcomePage.signUpButton')
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(VStack/* VStack */.g, {
                  className: "w-6"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(PinkNeonButton/* PinkNeonButton */.u, {
                  onClick: props.onClickLoginButton,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* Text */.x, {
                    children: t('WelcomePage.loginButton')
                  })
                })]
              })]
            })
          })]
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/views/parts/commons/GlobalNavigationHeader/useProps.ts
var GlobalNavigationHeader_useProps = __webpack_require__(2317);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/services/PagePathService.ts
var PagePathService = __webpack_require__(19);
;// CONCATENATED MODULE: ./src/views/pages/WelcomePage/useProps.ts



var useProps = function useProps() {
  var router = (0,next_router.useRouter)();
  return {
    onClickLoginButton: function onClickLoginButton() {
      return router.push(PagePathService/* PagePathService.login */.v.login());
    },
    onClickSignUpButton: function onClickSignUpButton() {
      return router.push(PagePathService/* PagePathService.signup */.v.signup());
    },
    GlobalNavigationHeaderProps: (0,GlobalNavigationHeader_useProps/* useProps */.w)()
  };
};
;// CONCATENATED MODULE: ./src/views/pages/WelcomePage/index.tsx


function WelcomePage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WelcomePage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WelcomePage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WelcomePage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var WelcomePage = function WelcomePage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout, WelcomePage_objectSpread({}, useProps()));
};
;// CONCATENATED MODULE: ./src/pages/welcome/index.tsx


/***/ }),

/***/ 681:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welcome",
      function () {
        return __webpack_require__(5500);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4804,4050,9774,2888,179], function() { return __webpack_exec__(681); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);